<template>
  <div class="page-wrapper" style="z-index: 1;">
    <h1>Member Administrator</h1>

    <div class="row justify-content-md-center">
      <div class="col-xxl-6 col-xl-6 col-lg-8 col-md-8">
        <div class="MemberList_card p-4">
          <div class="memberAdmin-header text-center mb-4">
            <div
              class="memberAdmin-header-content d-flex align-items-center justify-content-center mb-2"
            >
              <h2 class="mb-0">Member Administrators</h2>
              <button
                class="add-member-icon split btn-no-focus d-flex justify-content-center align-items-center flex-shrink-0"
                v-b-tooltip.hover
                title="Add Member"
                id="add-member-btn "
                @click="addMemberModal()"
                v-if="addBtn"
              >
                <i class="fa fa-plus"></i>
              </button>
            </div>
            <p class="pt-1 m-0 px-lg-2">
              Member Admins are additional accounts that you can add, that will
              have access to your dashboard.
            </p>
          </div>
          <div class="memberAdmin-body pt-2">
            <h3 class="mb-3">Users</h3>
            <ul class="mb-0">
              <li
                class="d-flex justify-content-between align-items-start align-items-sm-center flex-column flex-sm-row"
                v-if="!activeMembers.length"
              >
                <div class="member_email">No users found</div>
              </li>
              <li
                class="d-flex justify-content-between align-items-start align-items-sm-center flex-column flex-sm-row"
                v-for="user in activeMembers"
                :key="user.id + '-' + user.status"
              >
                <div class="member_email">
                  {{ user.email }}
                </div>
                <div class="action-btns d-flex align-items-center">
                  <button
                    v-if="isRoot && user.status !== 'S'"
                    class="d-flex justify-content-center align-items-center flex-shrink-0 action-btnwrapper suspend-btn btn-warning"
                    v-b-tooltip.hover
                    title="Suspend"
                    @click="confirmModal('suspend', user)"
                  >
                    <i class="fas fa-ban"></i>
                  </button>
                  <button
                    v-if="isRoot && user.status === 'S'"
                    class="d-flex justify-content-center align-items-center flex-shrink-0 rounded-circle"
                    style="width: 32px; height: 32px; padding: 0; font-size: 14px; background-color: #28a745; color: white; border: none;"
                    v-b-tooltip.hover
                    title="Activate"
                    @click="confirmModal('activate', user)"
                  >
                    <i class="fas fa-check"></i>
                  </button>

                  <!-- <button
                    v-if="isRoot &&user.status != 'S'"
                    class=" d-flex justify-content-center align-items-center flex-shrink-0 action-btnwrapper btn-primary"
                    v-b-tooltip.hover
                    title="Enable cc email"
                    @click="emailModal(user.email)"
                  >
                    <i class="far fa-envelope"></i>
                  </button> -->
                  <button
                   v-if="isRoot"
                    class=" d-flex justify-content-center align-items-center flex-shrink-0 action-btnwrapper btn-danger"
                    v-b-tooltip.hover
                    title="Delete"
                    @click="confirmModal('delete', user)"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </li>

              <!-- <member-admin-list-content
                :reps="activeReps"
                type="all"
                @onSuccess="getAll"
                 @emailSelected="handleEmailSelection"
              /> -->
            </ul>

            <hr class="my-4" />
            <h3 class="mb-3">Pending Users</h3>
            <ul class="mb-0">
              <li
                class="d-flex justify-content-between align-items-start align-items-sm-center flex-column flex-sm-row"
                v-if="!pendingMembers.length"
              >
                <div class="member_email">No Pending users found</div>
              </li>
               <li
                class="d-flex justify-content-between align-items-start align-items-sm-center flex-column flex-sm-row"
                v-for="user in pendingMembers"
                :key="user.id + '-' + user.status"
              >
                <div class="member_email">
                  {{ user.email }}
                </div>
                <div class="action-btns d-flex align-items-center">
                  <button
                    v-if="isRoot &&user.status !== 'S'"
                    class="d-flex justify-content-center align-items-center flex-shrink-0 action-btnwrapper suspend-btn btn-warning"
                    v-b-tooltip.hover
                    title="Suspend"
                    @click="confirmModal('suspend', user)"
                  >
                    <i class="fas fa-ban"></i>
                  </button>
                  <button
                    v-if="isRoot &&user.status === 'S'"
                    class="d-flex justify-content-center align-items-center flex-shrink-0 rounded-circle"
                    style="width: 32px; height: 32px; padding: 0; font-size: 14px; background-color: #28a745; color: white; border: none;"
                    v-b-tooltip.hover
                    title="Activate"
                    @click="confirmModal('activate', user)"
                  >
                    <i class="fas fa-check"></i>
                  </button>

                  <!-- <button
                    v-if="isRoot && user.status != 'S'"
                    class=" d-flex justify-content-center align-items-center flex-shrink-0 action-btnwrapper btn-primary"
                    v-b-tooltip.hover
                    title="Enable cc email"
                    @click="emailModal(user.email)"
                  >
                    <i class="far fa-envelope"></i>
                  </button> -->
                  <button
                    v-if="isRoot"
                    class=" d-flex justify-content-center align-items-center flex-shrink-0 action-btnwrapper btn-danger"
                    v-b-tooltip.hover
                    title="Delete"
                    @click="confirmModal('delete', user)"
                  >
                    <i class="far fa-trash-alt"></i>
                  </button>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <MemberAdminAdd @created="onCreateSuccess" />
    <MemberAdminEmail :email="selectedEmail" @onSubmit="handleCCSubmit" />
    <ConfirmModal
      :visible="isConfirmVisible"
      :title="confirmTitle"
      :message="confirmMessage"
      @cancel="handleCancel"
      :userId="userId"
      @success="handleSuccess"
    />
  </div>
</template>
<script>
// import MemberAdminListContent from "./MemberAdminListContent.vue";
import MemberAdminAdd from "./MemberAdminAdd.vue";
import MemberAdminEmail from "./MemberAdminEmail.vue";
import ConfirmModal from "./ConfirmModal.vue";
import axios from "axios";
import { mapGetters } from "vuex";


export default {
  name: "MemberAdminList",
  components: {
    MemberAdminAdd,
    MemberAdminEmail,
    ConfirmModal,
    // MemberAdminListContent,
  },
  data() {
    return {
      isConfirmVisible: false,
      confirmTitle: "",
      confirmMessage: "",
      confirmAction: "",
      activeMembers: [],
      pendingMembers: [],
      selectedEmail: null,
      addBtn: false,
      userId: null,
    };
  },

  methods: {
    onCreateSuccess() {
      this.getAll();
      this.$bvModal.hide("add-member-btn");
    },
    //adddin the method to fetch all member admin list
    getAll() {
      const url = `get-member-admin-details`;
      let loader = this.$loading.show();

    axios
      .get(url, {
        params: {
          is_root: this.isRoot // send 1 or 0 based on Vuex state
        }
      })
        .then((res) => {
          const data = res.data.data;
          this.addBtn = data.show_add_user_button;

          this.activeMembers = [...data.user_list];
          this.pendingMembers = [...data.pending_user_list];
        })
        .catch(() => {
          this.addBtn = false;
          this.activeMembers = [];
          this.pendingMembers = [];
        })
        .finally(() => {
          loader.hide();
        });
    },

    addMemberModal() {
      this.$bvModal.show("add-member-btn");
    },
    emailModal(email) {
      this.selectedEmail = email;
      this.$bvModal.show("email-modal-btn");
    },
    async confirmModal(action, user) {
      if (action === "suspend") {
        this.confirmTitle = "Suspend Admin";
        this.confirmMessage = "Do you want to suspend this admin?";
        this.confirmAction = "suspend";
      } else if (action === "delete") {
        this.confirmTitle = "Delete Admin";
        this.confirmMessage = "Do you want to delete this admin?";
        this.confirmAction = "delete";
      } else if (action === "activate") {
        this.confirmTitle = "Activate Admin";
        this.confirmMessage = "Do you want to activate this admin?";
        this.confirmAction = "activate";
      }
      this.userId = user.id;

      this.isConfirmVisible = true;
    },
    handleCancel() {
      this.isConfirmVisible = false;
      this.userId = null;
      this.confirmTitle = "";
      this.confirmMessage = "";
      this.confirmAction = "";
    },
    handleSuccess() {
      this.isConfirmVisible = false;
      this.userId = null;
      this.confirmTitle = "";
      this.confirmMessage = "";
      this.confirmAction = "";
      this.getAll();
    },

        handleCCSubmit(payload) {
      const url = `update-email-cc`;
      let loader = this.$loading.show();
      axios.post(url, payload)
        .then((res) => {
          this.$notify(res.data.message); 
          this.$bvModal.hide("email-modal-btn");
        })
        .catch((err) => {
          this.$notify(err.response.data.message, "error"); 
        })
        .finally(() => {

          loader.hide();
         
        });
    },
  },

  created() {
    this.getAll();
  },

  computed: {
    ...mapGetters(["isRoot"])
  }


};
</script>
<style src="@/assets/css/memberadministrator.css"></style>
